module.exports = __webpack_public_path__ + "static/media/bbc_news_entertainment-arts-35278872_plot.531cf535.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_entertainment-arts-35278872_plot.png
// module id = 347
// module chunks = 0